// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1151":"8797d043","1749":"1cbaf5ba","8415":"3b56eee5"}[chunkId] + ".chunk.css";
};